import { motion } from "framer-motion";

const plans = [
  {
    name: "免费版",
    subtitle: "个人用户",
    price: "免费",
    oldPrice: "中途收费",
    features: [
      "不限制记录数量",
      "5 级子域名",
      "600s TTL 最低值",
      "支持国家、大洲、搜索引擎智能线路",
      "2 条 URL 转发",
      "10 条负载均衡",
      "支持 API 接口",
      "支持域名共享",
      "支持批量操作"
    ]
  },
  {
    name: "专业版",
    subtitle: "个人用户",
    price: "¥9.90/月",
    oldPrice: "原价 ¥12.00/月",
    features: [
      "可用性 SLA 99.90%",
      "不限制记录数量",
      "20 级子域名",
      "120s TTL 最低值",
      "支持国家、大洲、搜索引擎智能线路",
      "5 条 URL 转发",
      "100 条负载均衡",
      "支持 API 接口",
      "支持域名共享",
      "支持批量操作"
    ],
    recommended: true // 👈 标记推荐
  },
  {
    name: "企业版",
    subtitle: "中小型企业",
    price: "¥39.90/月",
    oldPrice: "原价 ¥49.00/月",
    features: [
      "可用性 SLA 99.99%",
      "不限制记录数量",
      "30 级子域名",
      "60s TTL 最低值",
      "支持国家、大洲、搜索引擎、运营商、中国境内外、中国大区等智能线路",
      "10 条 URL 转发",
      "100 条负载均衡",
      "支持 API 接口",
      "支持域名共享",
      "支持批量操作"
    ]
  },
  {
    name: "旗舰版",
    subtitle: "大型企业",
    price: "¥139.00/月",
    oldPrice: "原价 ¥189.00/月",
    features: [
      "可用性 SLA 100%",
      "不限制记录数量",
      "50 级子域名",
      "1s TTL 最低值",
      "支持国家、大洲、搜索引擎、运营商、中国境内外、中国大区、中国省份等智能线路",
      "国外智能线路分大洲、国家、地区",
      "10 条 URL 转发",
      "100 条负载均衡",
      "支持 API 接口",
      "支持域名共享",
      "支持批量操作"
    ]
  }
];

const Pricing = () => {
  return (
    <section id="pricing" className="bg-slate-50 py-24 px-6 text-center">
      <h2 className="text-4xl font-bold mb-16 text-gray-800">套餐价格</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {plans.map((plan, idx) => (
          <motion.div
            key={idx}
            className={`relative flex flex-col justify-between h-full rounded-2xl border shadow ${
              plan.recommended
                ? "border-orange-500 shadow-md"
                : "border-gray-200 shadow-sm"
            } bg-white transition hover:shadow-lg`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.1 }}
            viewport={{ once: true }}
          >
            {/* 推荐角标 */}
            {plan.recommended && (
              <span className="absolute top-2 right-2 bg-orange-500 text-white text-xs font-semibold px-2 py-0.5 rounded">
                推荐
              </span>
            )}

            <div className="p-8 pb-4">
              <h3 className="text-xl font-bold text-indigo-700 mb-1">{plan.name}</h3>
              <p className="text-sm text-gray-500 mb-4">{plan.subtitle}</p>
              <p className="text-3xl font-bold text-gray-800 mb-1">{plan.price}</p>
              {plan.oldPrice && (
                <p className="text-xs text-gray-400 line-through mb-4">{plan.oldPrice}</p>
              )}
              <ul className="text-sm text-gray-700 space-y-2 text-left">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-green-500 font-semibold mt-0.5">✔</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="px-8 pb-8">
              <button
                onClick={() => {
                  if (plan.name === "免费版") {
                    // window.location.href = "/register";
                  }
                }}
                className={`w-full py-3 rounded-lg ${
                  plan.name === "免费版"
                    ? "bg-orange-500 text-white hover:bg-orange-600"
                    : "bg-gray-100 text-gray-400 cursor-not-allowed"
                } font-medium transition`}
                disabled={plan.name !== "免费版"}
              >
                {plan.name === "免费版" ? "立即使用" : "暂未发布"}
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Pricing;